<template>
  <div class="right">
    <span class="spen" >{{ $t('label.Account_Settings') }}</span>
    <Loading v-if="isLoading" />
    <div class="daohang">
      <ul class="ul">
        <router-link :to="{ name: 'User' }" tag="li" >{{ $t('label.Base_Information') }}</router-link>
        <router-link :to="{ name: 'Safe' }" tag="li" >{{ $t('label.Account_Security') }}</router-link>
        <router-link :to="{ name: 'Bind' }" tag="li" >{{ $t('label.Third_Party_Accounts') }}</router-link>
        <router-link :to="{ name: 'Address' }" tag="li" >{{ $t('label.Receiving_Address') }}</router-link>
      </ul>
    </div>
    <div class="tit">
      <div class="tit-left">
        <img src="../../../assets/order/safe.png" alt="" />
      </div>
      <div class="tit-right">
        <div class="tit-right-t" >{{ $t('label.Security_Level') }}：{{ dengji }}</div>
        <div class="tit-right-b" >{{ $t(daren) }}</div>
      </div>
    </div>
    <div class="conter">
      <div class="list" v-if="phone">
        <div><img src="../../../assets/order/safe1.png" alt="" /></div>
        <div class="top">{{ $t('label.Mobile_phone_number') }}</div>
        <div class="center">{{ phone }}</div>
        <div class="bottom" @click="change" >{{ $t('button.Edit_Mobile_Number') }}</div>
        <div class="img">
          <img src="../../../assets/order/you2.png" alt="" />
        </div>
      </div>
      <div class="list list1">
        <div><img src="../../../assets/order/safe2.png" alt="" /></div>
        <div class="top" >{{ $t('label.Login_Password') }}</div>
        <div class="center" >{{ $t('message.safe-message-003') }}</div>
        <div class="bottom" @click="password" >{{ $t('button.Edit_Password') }}</div>
        <div class="img">
          <img src="../../../assets/order/you2.png" alt="" />
        </div>
      </div>
      <div class="list list2">
        <div><img src="../../../assets/order/safe3.png" alt="" /></div>
        <div class="top" >{{ $t('label.Payment_Password') }}</div>
        <div class="center" >{{ $t('message.safe-message-004') }}</div>
        <div class="bottom" @click="paypass" >{{ $t('button.Edit_Payment_Password') }}</div>
        <div class="img">
          <img v-if="password1" src="../../../assets/order/you2.png" alt="" />
          <img v-else src="../../../assets/order/you1.png" alt="" />
        </div>
      </div>
      <div class="list list3">
        <div><img src="../../../assets/order/safe4.png" alt="" /></div>
        <div class="top" >{{ $t('common.Email') }}</div>
        <div class="center">{{ youxiang }}</div>
        <div class="bottom" @click="mail" >{{ $t('button.Associated_Email') }}</div>
        <div class="img">
          <img v-if="email" src="../../../assets/order/you2.png" alt="" />
          <img v-else src="../../../assets/order/you1.png" alt="" />
        </div>
      </div>
      <div class="list list4">
        <div><img src="../../../assets/order/safe5.png" alt="" /></div>
        <div class="top" >{{ $t('label.Real-name_authentication') }}</div>
        <div class="center">{{ name }} {{ idcard }}</div>
        <div class="bottom" @click="autonym" >{{ $t('button.View_Real_Rame_Information') }}</div>
        <div class="img">
          <img v-if="idcard1" src="../../../assets/order/you2.png" alt="" />
          <img v-else src="../../../assets/order/you1.png" alt="" />
        </div>
      </div>
      <div class="list list5">
        <div><img src="../../../assets/order/safe.png" alt="" /></div>
        <div class="top" >{{ $t('label.Delete_Account') }}</div>
        <div class="center">{{ account }}</div>
        <div class="bottom" @click="cancelAccount" >{{ $t('button.Delete_Account') }}</div>
        <div class="img">
          <img src="../../../assets/order/you2.png" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { post, get } from '@/utils/request'
import { setCookie, getCookie, delCookie } from '@/utils/cookie'
export default {
  data() {
    return {
      account: '',
      phone: '',
      isLoading: true,
      idcard: '',
      name: '',
      email: true,
      idcard1: true,
      password1: true,
      dengji: '',
      daren: 'message.safe-message-001',
      youxiang: ''
    }
  },
  created() {
    this.getorder()
    this.zhifu()
    this.getbindingnum()
  },
  methods: {
    getorder() {
      get('api/member/selMemberInfo').then((res) => {
        this.isLoading = false
        this.youxiang = res.data.data.email
        this.account=res.data.data.userName
        if (res.data.data.phone) {
          this.phone = res.data.data.phone.replace(res.data.data.phone.substr(3, 4), '****')
        }
        this.name = this.nameFormat(res.data.data.realName)
        this.idcard = this.formatIDcard(res.data.data.idCard)
        if (res.data.data.email) {
          this.email = true
        } else {
          this.email = false
        }
        if (res.data.data.idCard) {
          this.idcard1 = true
        } else {
          this.idcard1 = false
        }
      })
    },
    zhifu() {
      get('api/account/getisaccountpay').then((res) => {
        if (res.data.msg == '1') {
          this.password1 = true
        } else {
          this.password1 = false
        }
      })
    },
    getbindingnum() {
      get('api/member/getbindingnum').then((res) => {
        if (res.data.data == 2) {
          this.dengji = this.$t('common.Low')
        } else if (res.data.data == 3 || res.data.data == 4) {
          this.dengji = this.$t('common.Middle')
        } else if (res.data.data == 5) {
          this.dengji = this.$t('common.high')
          this.daren = this.$t('message.safe-message-002')
        } else {
          this.dengji = this.$t('common.Unknown')
        }
      })
    },
    //将姓名进行隐藏处理
    nameFormat(item) {
      if (!item) return ''
      let str = item
      if (str.length == 2) {
        str = str.toString().replace(/^([^\x00-\xff])([^\x00-\xff]{0,})([^\x00-\xff])/g, '$1*')
      } else if (str.length == 3) {
        str = str.toString().replace(/^([^\x00-\xff])([^\x00-\xff]{0,})([^\x00-\xff])/g, '$1*$3')
      } else if (str.length == 4) {
        str = str.toString().replace(/^([^\x00-\xff])([^\x00-\xff]{0,2})([^\x00-\xff])/g, '$1**$3')
      } else if (str.length > 4) {
        str = str.toString().replace(/^([^\x00-\xff])([^\x00-\xff]{0,3})([^\x00-\xff])/g, '$1***$3')
      } else {
      }
      // str = str.toString().replace(/^([^\x00-\xff])([^\x00-\xff]{1,3})([^\x00-\xff])/g , '$1**$3')
      return str
    },
    //将身份证号进行隐藏处理
    formatIDcard(value) {
      if (!value) return ''
      let str = value
      str = str.toString().replace(/^(.{6})(?:\w+)(.{4})$/, '$1********$2')
      return str
    },
    password() {
      this.$router.push({
        name: 'Changepassword'
      })
    },
    change() {
      this.$router.push({
        name: 'Select'
      })
    },
    paypass() {
      this.$router.push({
        name: 'Paypass'
      })
    },
    mail() {
      this.$router.push({
        name: 'Mail'
      })
    },
    autonym() {
      this.$message.warning({
        message: this.$t('message.developing')
      })
      // this.$router.push({
      //   name: 'Autonym',
      // });
    },
    cancelAccount() {
      this.$confirm(this.$t('message.safe-message-005'), this.$t('common.Confirmation'), {
        confirmButtonText: this.$t('button.Confirm'),
        cancelButtonText: this.$t('button.Cancel'),
        type: 'warning'
      }).then(() => {
        post('api/users/cancelAccount').then((res) => {
          delCookie('username')
          delCookie('memberId')
          delCookie('Authorization')
          this.$router.go(0)
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.right {
  width: 1006px;
  padding-top: 34px;
  padding-left: 27px;
  background: #fff;
  .spen {
    font-size: 26px;
    font-weight: 600;
    color: #616161;
  }

  .daohang {
    font-size: 15px;
    color: #272727;
    margin-right: 25px;
    height: 60px;

    .ul {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0;
      width: 400px;
      li {
        list-style: none;
        cursor: pointer;
        &.router-link-exact-active.router-link-active {
          color: #3661fe;
        }
      }
    }
  }
  .tit {
    width: 978px;
    height: 94px;
    display: flex;
    background: url('../../../assets/order/safeback.jpg') no-repeat center center;
    &-left {
      width: 42px;
      height: 52px;
      margin-left: 20px;
      margin-top: 20px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    &-right {
      margin-left: 32px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      &-t {
        font-size: 16px;
        color: #333;
      }
      &-b {
        color: #555;
        margin-top: 10px;
      }
    }
  }
  .conter {
    width: 978px;
    display: flex;
    flex-wrap: wrap;
    .list {
      width: 313px;
      height: 174px;
      background: #dce8f4;
      position: relative;
      margin-top: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      padding: 60px 0;
      .img {
        position: absolute;
        right: 10px;
        top: 10px;
      }
      .top {
        font-size: 18px;
        color: #343434;
      }
      .center {
        color: #6b6f70;
        transform: scale(1);
      }
      .bottom {
        width: 163px;
        height: 31px;
        text-align: center;
        line-height: 31px;
        border: 2px solid #3f6efc;
        color: #1851ff;
        border-radius: 25px;
        cursor: pointer;
      }
    }
    .list2,
    .list1,
    .list4 {
      margin-left: 19px;
    }
    .list5 {
      margin-left: 19px;
    }
    .list1 {
      background: #f9ebe0;
    }
    .list2 {
      background: #e9f5eb;
    }
    /*.list3 {*/
    /*  background: #efe4ec;*/
    /*}*/
    .list4 {
      background: #f9ebe0;
    }
    .list5 {
      background: #e9f5eb;
    }
  }
}
</style>
